import React from 'react';

import { GameScoreModel } from '../../models/gameScoreModel';
import './HighScore.scss';
import TrophyIcon from '../../assets/leaderboard/Trophy.svg';

interface Props {
  gameScore: GameScoreModel;
  highScore: boolean;
}

const HighScore = ({
  highScore = false,
  gameScore: {
    game, island, score, total,
  },
}: Props): React.ReactElement => (
  <div className="high-score">
    <div>
      {game.name}
    </div>

    <div>
      {island?.name}
    </div>

    <div>
      {`${score}/${total}`}
    </div>

    {highScore && (
      <span className="trophy">
        <img src={TrophyIcon} className="icon" alt="Trophy!" />
      </span>
    )}

  </div>
);

export default HighScore;
